export default class DeviceDetection {
  mac?: string
  rssi?: number
  timestamp?: Date
  foundAt?: Date
  stay?: number

  constructor(attrs = {}) {
    Object.assign(this, attrs)
  }
}
